import React from 'react';
import PropTypes from 'prop-types';

import { injectIntl, intlShape } from 'react-intl';
import { is } from 'ramda';
import { connect } from 'react-redux';

import { actions } from 'store/floodlight';

import FloodlightInner from '../components/FloodlightInner';

const makeLocaleMessage =
  fm =>
  (id, values = {}) =>
    is(String, id) ? fm({ id }, values) : null;

class FloodlightContainer extends React.Component {
  constructor() {
    super();
    this.load = () => this.props.loadFloodlight();
  }

  componentDidMount() {
    this.load();
  }

  render() {
    const {
      intl: { formatMessage },
    } = this.props;

    const data = {
      lastUpdate: this.props.lastUpdate,
      groups: this.props.groups,
    };

    const localeMessage = makeLocaleMessage(formatMessage);

    return <FloodlightInner localeMessage={localeMessage} data={data} />;
  }
}

FloodlightContainer.propTypes = {
  intl: intlShape,
  loadFloodlight: PropTypes.func.isRequired,
  lastUpdate: PropTypes.any,
  groups: PropTypes.object,
};

const mapStateToProps = state => ({
  lastUpdate: state.floodlight.latest,
  groups: state.floodlight.groups,
});

export default connect(mapStateToProps, { loadFloodlight: actions.loadFloodlight })(injectIntl(FloodlightContainer));
